module.exports = __webpack_public_path__ + "img/turtle-ru.163976f7.png";